import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "@/components/toast/CustomToast";
import {
  publishRosterApi,
  unpublishRosterApi,
} from "@/pages/roster-create/services/rosterCreateApi";
import { invalidateRosterPublicationCaches } from "@/pages/roster-create/services/rosterPublicationCache";

type RosterPublicationDate = {
  readonly year?: number | null;
  readonly month?: number | null;
};

export type UseRosterPublicationControlsParams = {
  readonly curDate: RosterPublicationDate | null | undefined;
  readonly scheduleId: string | null | undefined;
  readonly selectedGroupId: string | null | undefined;
};

export function useRosterPublicationControls({
  curDate,
  scheduleId,
  selectedGroupId,
}: UseRosterPublicationControlsParams) {
  const queryClient = useQueryClient();

  const publishMutation = useMutation({
    mutationFn: () =>
      publishRosterApi({
        groupId: selectedGroupId,
        scheduleId: scheduleId ?? "",
      }),
    onSuccess: async () => {
      toast.success("근무표가 성공적으로 발행되었습니다!");
      await invalidateRosterPublicationCaches(queryClient, {
        curDate,
        selectedGroupId,
        includeAlarms: true,
      });
    },
  });

  const unpublishMutation = useMutation({
    mutationFn: () => unpublishRosterApi({ scheduleId: scheduleId ?? "" }),
    onSuccess: async () => {
      toast.success("마감이 철회되었습니다.");
      await invalidateRosterPublicationCaches(queryClient, {
        curDate,
        selectedGroupId,
      });
    },
  });

  return {
    publishRoster: publishMutation.mutate,
    isPublishPending: publishMutation.isPending,
    unPublishRoster: unpublishMutation.mutate,
    isUnPublishPending: unpublishMutation.isPending,
  };
}
